export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "Your Experience", path: "/experience" },
  { label: "Gallery & Reviews", path: "/gallery" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

export const PACKAGES = [
  {
    name: "Silly & Playful",
    tag: "Our most popular",
    tagline: "All the laughs, shakes, and good vibes your group deserves.",
    slug: "silly",
    cocktails: ["Cosmopolitan", "Passion Fruit Martini", "Mojito", "Sex on the Beach"],
    features: ["90-minute hands-on class", "All ingredients & equipment provided"],
    accent: "#D4A853",
  },
  {
    name: "Bright & Confident",
    tag: "Seasonal experience",
    tagline: "A flavour-led journey with a twist of flair and seasonal soul.",
    slug: "bright",
    cocktails: ["Pineapple Daiquiri", "Old Fashioned", "Mojito", "Aperol Spritz"],
    features: ["2-hour immersive experience", "Personalised recipe cards"],
    accent: "#C77D8A",
  },
  {
    name: "Elegant & Timeless",
    tag: "Premium Experience",
    tagline: "A refined VIP masterclass for those who want nothing but the best.",
    slug: "elegant",
    cocktails: ["Pornstar Martini", "Classic Margarita", "Mojito", "Negroni"],
    features: ["2.5-hour VIP experience", "Dedicated event coordinator"],
    accent: "#8A7FBF",
  },
];

export const SPIRIT_EXPERIENCES = [
  { spirit: "Tequila", desc: "Explore the vibrant world of agave — from classic Margaritas to smoky Palomas and beyond.", icon: "🌵" },
  { spirit: "Rum", desc: "Sail through tropical flavours with Mojitos, Daiquiris, Mai Tais, and Caribbean-inspired creations.", icon: "🏝️" },
  { spirit: "Gin", desc: "Discover botanical brilliance — craft G&Ts, Negronis, Brambles, and bespoke gin infusions.", icon: "🌿" },
];

export const TESTIMONIALS = [
  { name: "Sophie R.", text: "Absolutely incredible experience for my hen do! The girls loved every second. The cocktails were delicious and the instructor was so much fun. Highly recommend!", rating: 5 },
  { name: "James T.", text: "We booked Silly Butterfly for our corporate team social and it exceeded all expectations. Professional, engaging, and the perfect ice-breaker for the team.", rating: 5 },
  { name: "Priya K.", text: "My 30th birthday was made so special thanks to Silly Butterfly. The setup was gorgeous, the cocktails were amazing, and it was SO easy to organise. 10/10!", rating: 5 },
  { name: "Lauren M.", text: "Such a fun, unique activity! We laughed the whole time and learned to make drinks we'll definitely be recreating at home. The team were brilliant.", rating: 5 },
  { name: "David W.", text: "Booked this for my partner's birthday. The whole experience was seamless from enquiry to the event itself. Top quality service and fantastic drinks.", rating: 5 },
  { name: "Emily C.", text: "We've now booked Silly Butterfly for three events and every single time they deliver. Fun, professional, and always a crowd-pleaser!", rating: 5 },
];

export const FAQS = [
  {
    q: "Can I choose which cocktails are made?",
    a: "Absolutely. You are welcome to select your favourite cocktails from our menu when booking. If you have something specific in mind, simply get in touch and we will tailor the experience to suit your group.",
  },
  {
    q: "Do you offer alcohol-free options?",
    a: "Yes, we offer a range of mocktails and alcohol-free options so that everyone can enjoy the experience.",
  },
  {
    q: "Where do the cocktail classes and events take place?",
    a: "We offer a fully mobile cocktail service, bringing everything required directly to your chosen venue. This could be your home, an Airbnb, office, garden, hired venue, party house or private event space.",
  },
  {
    q: "What areas do you cover?",
    a: "We cover a wide range of locations throughout the UK, including Nottinghamshire, Derbyshire, Leicestershire, Sheffield, Birmingham, Manchester, Leeds, Lincoln, York, Hull, Northampton, Peterborough, Cambridge and Liverpool, along with surrounding areas.\n\nDo get in touch and we will do our best to accommodate. Additional travel charges may apply depending on distance.",
  },
  {
    q: "What is included in the price?",
    a: "Your experience includes all ingredients, professional cocktail equipment, glassware, garnishes, ice and a dedicated cocktail host. We take care of everything needed for the session, so you can relax and enjoy the occasion.",
  },
  {
    q: "Do I need to provide anything?",
    a: "We simply ask for a suitable table for the setup, along with access to water where possible. If you do not have a table available, we can provide one for an additional £15.",
  },
  {
    q: "What happens on the day of your event?",
    a: "Your bartender plans to arrive 30 minutes before the start time to set up. Then your cocktail experience will run for about two hours. At the end, please allow 30 minutes for the bartender to clear away equipment and glassware.",
  },
  {
    q: "Can I book if my event details are still changing?",
    a: "Yes, of course. We understand that details such as guest numbers, venue and timings may change while planning your event. You can secure your date while finalising the finer details.\n\nA £30 non-refundable booking fee is required to confirm your booking. If your guest numbers change, please let us know as soon as possible so we can update your booking, ingredients and final balance. Final numbers must be confirmed no later than 10 days before your event.",
  },
  {
    q: "Can I book at short notice?",
    a: "We recommend booking as early as possible, especially during busy periods. However, if your event is coming up soon, do get in touch and we will do our best to accommodate last-minute bookings where possible.",
  },
  {
    q: "What is your payment and cancellation policy?",
    a: "To secure your booking, a £30 non-refundable booking fee is required. The remaining balance must be paid no later than 10 days before your event. If you cancel more than 10 days before your event, any payments made beyond the booking fee will be refunded. Cancellations made within 10 days of the event are non-refundable.",
  },
  {
    q: "Is the cocktail class suitable for beginners?",
    a: "Our cocktail classes are designed to be relaxed, enjoyable and easy to follow. Your host will guide everyone step by step, ensuring each guest creates delicious drinks, regardless of experience.",
  },
];
